import React from 'react';

const Episodes = ({ episodes, onChangeEpisode, currentEpisode }) =>
  episodes.map((episode, idx) => {
    const { documentaryEpisodesVideo: videoCode } = episode;

    const changeEpisode = () => onChangeEpisode(idx, videoCode);

    const longText = `Episode ${idx + 1}`;
    const shortText = `Ep.${idx + 1}`;

    return (
      <button
        className={`documentary-episodes__button ${currentEpisode === idx ? 'button-active' : ''}`}
        key={idx + 1}
        onClick={changeEpisode}
        title={longText}
      >
        <span>{longText}</span>
        <span>{shortText}</span>
      </button>
    );
  });

export default Episodes;
